module.exports = "../study/imgs/maps/Kanagawa/S8/Agriculture/RiceQ/Kanagawa_RiceQ_HadGEM2_RCP26_End.png";